import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_modular-ui-4/artifacts/m24395kj_logo.png";

const COLS = [
    {
        title: "Studio",
        links: [
            { label: "About", to: "/about" },
            { label: "Services", to: "/services" },
            { label: "Blog", to: "/blog" },
            { label: "Contact", to: "/contact" },
        ],
    },
    {
        title: "Services",
        links: [
            { label: "Software Solutions", to: "/services" },
            { label: "SaaS Products", to: "/services" },
            { label: "Digital Marketing", to: "/services" },
            { label: "Brand & UI", to: "/services" },
        ],
    },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t-4 border-ink bg-ink text-cream mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Link to="/" className="flex items-center gap-3">
                            <span className="w-12 h-12 rounded-xl bg-ink border-2 border-cream flex items-center justify-center overflow-hidden">
                                <img src={LOGO_URL} alt="Technovale Solutions" className="w-full h-full object-contain" />
                            </span>
                            <span className="font-display text-2xl font-extrabold tracking-tight leading-none">
                                Technovale
                                <span className="block text-xs font-mono text-cream/60 mt-1 tracking-widest">SOLUTIONS</span>
                            </span>
                        </Link>
                        <p className="mt-5 font-body text-cream/70 text-base max-w-md leading-relaxed">
                            A software & digital marketing studio building bold SaaS
                            products and growth engines for ambitious teams.
                        </p>
                        <Link
                            to="/contact"
                            data-testid="footer-cta-link"
                            className="mt-8 inline-flex items-center gap-2 font-display text-3xl font-extrabold underline decoration-brand-yellow decoration-4 underline-offset-8 hover:text-brand-yellow transition-colors"
                        >
                            Start a project <ArrowUpRight size={28} />
                        </Link>
                    </div>

                    {COLS.map((col) => (
                        <div key={col.title} className="md:col-span-2">
                            <h4 className="label-mono text-brand-yellow mb-4">{col.title}</h4>
                            <ul className="space-y-2">
                                {col.links.map((l) => (
                                    <li key={l.label}>
                                        <Link
                                            to={l.to}
                                            className="font-body text-cream/80 hover:text-cream hover:underline underline-offset-4"
                                        >
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-3">
                        <h4 className="label-mono text-brand-yellow mb-4">Studio</h4>
                        <p className="font-body text-cream/80 break-all">info@technovalesolutions.com</p>
                        <p className="font-body text-cream/80 mt-1">+91 (931) 074-5117</p>
                        <p className="font-body text-cream/60 mt-2">
                            188, Sector 48<br />Gurugram, HR
                        </p>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
                    <div>
                        <p className="label-mono text-cream/50">© 2026 Technovale Solutions</p>
                        <p className="label-mono text-cream/50">Built with bold ideas + good chai</p>
                    </div>
                    <div className="flex gap-6">
                        <Link
                            to="/privacy-policy"
                            className="label-mono text-cream/60 hover:text-cream hover:underline underline-offset-4 transition-colors"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/refund-policy"
                            className="label-mono text-cream/60 hover:text-cream hover:underline underline-offset-4 transition-colors"
                        >
                            Refund Policy
                        </Link>
                        <Link
                            to="/terms-and-conditions"
                            className="label-mono text-cream/60 hover:text-cream hover:underline underline-offset-4 transition-colors"
                        >
                            Terms & Conditions
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
